import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

import type { JiraContextData } from './jira-draft-data-command';

export interface JiraDraftDataForCreateAllCommandProperties extends CommandProperties {}

/**
 * Result type for the Jira context command.
 */
export type JiraDraftDataForCreateAllCommandResult = {
	// This type is no longer used in the platform version of the table
	success?: boolean;
	context?: JiraContextData;
	error?: string;
	/* Update draftWorkItems to be mandatory after cleaning ai_first_create_platformify_table */
	draftWorkItems?: any;
};

/**
 * A command sent by a bridge API client to retrieve Jira-specific context
 * information when operating in a Jira staging area environment.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to provide current Jira context information.
 */
export const JiraDraftDataForCreateAllCommand: CommandConstructor<
	JiraDraftDataForCreateAllCommandProperties,
	JiraDraftDataForCreateAllCommandResult
> = createCommand<
	JiraDraftDataForCreateAllCommandProperties,
	JiraDraftDataForCreateAllCommandResult
>('jira-context-for-create-all-command');
